/**
* @module index
* @author: liuxinyu
* @description:
* @since: 2020-07-09 16:30:31
*/
import React, { Component } from 'react';
import { Input, Checkbox, Button, message } from 'antd';
import jsrsasign from 'jsrsasign';
import { getLoginConfig, setLogin, getFrontUserCode } from '@/fetch/api/token.js';
import { setCookie, getCookie, removeCookie } from '@/utils/cookie';
import WebSocketProxy from '@/utils/webSocket';
import { Local } from '@/utils/local.js';
import { unloginQestion } from '@/fetch/api/question.js';
import { Encrypt } from '@/utils/encrypt.js';

const CryptoJS = require('crypto-js'); //引用AES源码js


export class LoginBox extends Component {
  state = {
    // loginConfig: null,
    account: undefined,
    password: undefined,
    remberPassword: false,
    baseUrl: `${window.location.origin}${process.env.REACT_APP_PATH}`,
    currentDomain: window.location.origin.indexOf('localhost') == -1 ? window.location.host : 'wxrcc.rel-s.yunduoketang.cn'
  };

  componentDidMount() {
    if (getCookie(`account_${this.state.currentDomain}`)) {
      this.setState({
        account: getCookie(`account_${this.state.currentDomain}`),
        remberPassword: true
      });
    }
  } // 加密密码


  encryptPassword = (psd, key) => {
    var encrypt_rsa = new jsrsasign.RSAKey();
    var prefix = "-----BEGIN PUBLIC KEY-----\n";
    var suffix = "\n-----END PUBLIC KEY-----";
    var publicKey = prefix + key + suffix;
    encrypt_rsa = jsrsasign.KEYUTIL.getKey(publicKey);
    var encStr = encrypt_rsa.encrypt(psd, encrypt_rsa);
    return encStr;
  }; //加密（AES/ECB/PKCS5Padding默认加密算法）

  encrypt = word => {
    const key = CryptoJS.enc.Utf8.parse('a1b2c3d4e5012345'); //16位

    let encrypted = '';

    if (typeof word == 'string') {
      let srcs = CryptoJS.enc.Utf8.parse(word);
      encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
    } else if (typeof word == 'object') {
      //对象格式的转成json字符串
      let data = JSON.stringify(word);
      let srcs = CryptoJS.enc.Utf8.parse(data);
      encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
    }

    return encrypted.toString();
  };
  handleLogin = () => {
    let {
      remberPassword,
      password,
      account,
      currentDomain,
      baseUrl
    } = this.state;
    let {
      loginConfig
    } = this.props;

    if (!account) {
      message.warning('请输入账号');
      return;
    }

    if (!password) {
      message.warning('请输入密码');
      return;
    }

    setLogin({
      "account": account,
      "password": this.encryptPassword(password, loginConfig.publicKey),
      "remeberMe": remberPassword ? 1 : 0,
      //1记住 0不记
      "type": 1
    }).then(res => {
      if (res.code == 1 && res.data.flag) {
        console.log(res.data.user, 'res.data.');
        let userInfo = {
          userId: res.data.user.id
        };
        Local.set('userInfo', Encrypt(JSON.stringify(userInfo)));
        getFrontUserCode({
          caInfo: this.encrypt(`${res.data.user.id}~${currentDomain}`)
        }).then(async result => {
          console.log(result, 'resultresultresultresult');

          if (result.code == 1) {
            WebSocketProxy.loginWebsocket('general', 'login', 'login', res.data.user.id);
            let link = '';
            let relRecordId = '';
            let relHref = window.location.href; // 处理未登录做题同步

            if (Local.get('clientId') && Local.get(Local.get('clientId'))) {
              let currentClientId = Local.get('clientId');
              let params = {
                schoolId: res.data.user.schoolId,
                currentId: Local.get('unLoginRecordId') || ''
              };
              let data = Local.get(currentClientId);
              let unLoginDoingRes = await unloginQestion(params, data);

              if (unLoginDoingRes.code === '1') {
                relRecordId = unLoginDoingRes.data;
                Local.remove('clientId');
                Local.remove(currentClientId);
                Local.remove('paperId');
                Local.remove('unLoginRecordId');
              }

              console.log('unLoginDoingResunLoginDoingResunLoginDoingRes', unLoginDoingRes);

              if (window.location.href.indexOf('/lib/subject/doing') !== -1 || window.location.href.indexOf('/lib/subject/report') !== -1) {
                // 做题页地址
                let hrefArr = window.location.hash.split('/');
                hrefArr[4] = relRecordId;
                let hrefStr = hrefArr.join('/');
                relHref = window.location.origin + '/s/pc/' + hrefStr;
              }
            }

            console.log('relHrefrelHrefrelHref', relHref);

            if (window.location.href.includes('?')) {
              link = `${relHref}&code=${result.data}&schoolId=${res.data.user.schoolId}`;
            } else {
              link = `${relHref}?code=${result.data}&schoolId=${res.data.user.schoolId}`;
            } // 深海定制 未读消息强制跳转消息列表 


            const {
              companyMessageReach = null
            } = res.data;
            Local.set('res.data', JSON.stringify(res.data));

            if (companyMessageReach === 'ok') {
              if (link.includes('?')) {
                link = `${link}&companyMessageReach=ok`;
              } else {
                link = `${link}?companyMessageReach=ok`;
              }

              Local.set('link', link);
            }

            if (remberPassword) {
              setCookie(`account_${currentDomain}`, account);
            } else {
              if (getCookie(`account_${currentDomain}`)) {
                removeCookie(`account_${currentDomain}`);
              }
            }

            Local.remove('token');
            Local.remove('parentId'); // Local.remove('refresh_token')

            if (link.indexOf('/home/index') > -1) {
              Local.set('indexShowFlag', true);
            } else {
              Local.remove('indexShowFlag');
            }

            window.location.replace(link);
            window.location.reload();
          } else {
            message.warning('登录失败');
          }
        });
      } else {
        message.warning(res.data.msg);
      }
    });
  };

  render() {
    let {
      account,
      password,
      remberPassword
    } = this.state;
    let {
      loginConfig
    } = this.props;
    return <div data-inspector-line="180" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" className="login-box">
        <Input data-inspector-line="181" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" placeholder="请输入用户名/手机号/邮箱账号" prefix={<i data-inspector-line="183" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" className="iconfont iconyonghu"></i>} value={account} onChange={e => {
        this.setState({
          account: e.target.value
        });
      }} />
        <Input.Password data-inspector-line="191" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" placeholder="请输入密码" value={password} onChange={e => {
        this.setState({
          password: e.target.value
        });
      }} prefix={<i data-inspector-line="199" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" className="iconfont iconmima"></i>} suffix={visible => visible ? <i data-inspector-line="200" data-inspector-column="40" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" className="iconfont iconliulan"></i> : <i data-inspector-line="200" data-inspector-column="82" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" className="iconfont iconbukejian-"></i>} />
        <div data-inspector-line="202" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" className="rember-password">
          <Checkbox data-inspector-line="203" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" checked={remberPassword} onChange={e => {
          this.setState({
            remberPassword: e.target.checked
          });
        }}>记住我</Checkbox>
          <p data-inspector-line="206" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx"><a data-inspector-line="206" data-inspector-column="13" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" href="/login/forget?method=phone" className="forgetpwd">找回密码</a></p>
        </div>
        <Button data-inspector-line="208" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\LoginBox\\index.jsx" type="primary" className="login-button" onClick={this.handleLogin}>登录</Button>
      </div>;
  }

}
export default LoginBox;